<script setup>
import { computed } from 'vue';
import EmptyLayout from '@/Layouts/EmptyLayout.vue';

const props = defineProps({
  status: {
    type: Number,
    required: true,
  },
});

defineOptions({ layout: EmptyLayout });

const title = computed(() => ({
  403: 'Forbidden',
  404: 'Page Not Found',
  410: 'Gone',
  500: 'Server Error',
  503: 'Service Unavailable',
}[props.status]));

const description = computed(() => ({
  403: 'Sorry, you are forbidden from accessing this page.',
  404: 'Sorry, the page you are looking for could not be found.',
  410: 'Sorry, this resource is already used or expired',
  500: 'Whoops, something went wrong on our servers.',
  503: 'Sorry, we are doing some maintenance. Please check back soon.',
}[props.status]));
</script>

<template>
  <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <p class="text-base font-semibold text-indigo-600">
        {{ status }}
      </p>
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        {{ title }}
      </h1>
      <p class="mt-6 text-base leading-7 text-gray-600">
        {{ description }}
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <a
          href="/"
          class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold
          text-white shadow-sm hover:bg-indigo-500 focus-visible:outline
          focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Go back home
        </a>
        <a
          href="mailto:webmaster@ellera.no"
          class="text-sm font-semibold text-gray-900">Contact support <span aria-hidden="true">&rarr;</span></a>
      </div>
    </div>
  </main>
</template>
